import { render, staticRenderFns } from "./Alien.vue?vue&type=template&id=64755cab&scoped=true&"
import script from "./Alien.vue?vue&type=script&lang=js&"
export * from "./Alien.vue?vue&type=script&lang=js&"
import style0 from "./Alien.vue?vue&type=style&index=0&id=64755cab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64755cab",
  null
  
)

export default component.exports